import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { USAEPayMethodPage } from './usaepay-method.page';

const routes: Routes = [
  {
    path: '',
    component: USAEPayMethodPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class USAEPayMethodPageRoutingModule {}
